const Maestro = () => {
  return (
    <svg
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="21.1795" height="15" rx="3.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="21.1795"
        height="15"
        rx="3.5"
        stroke="#CFCFCF"
      />
      <path
        d="M13.2773 4.06909H8.90234V11.9311H13.2773V4.06909Z"
        fill="#7375CF"
      />
      <path
        d="M9.18015 8C9.17946 7.24283 9.35104 6.49543 9.6819 5.81438C10.0128 5.13333 10.4942 4.53647 11.0899 4.069C10.3523 3.48923 9.46642 3.12868 8.53359 3.02856C7.60076 2.92844 6.65858 3.09278 5.81474 3.50282C4.9709 3.91285 4.25945 4.55203 3.76171 5.34729C3.26396 6.14256 3 7.06181 3 8C3 8.93819 3.26396 9.85744 3.76171 10.6527C4.25945 11.448 4.9709 12.0871 5.81474 12.4972C6.65858 12.9072 7.60076 13.0716 8.53359 12.9714C9.46642 12.8713 10.3523 12.5108 11.0899 11.931C10.4942 11.4635 10.0128 10.8667 9.6819 10.1856C9.35104 9.50457 9.17947 8.75717 9.18015 8Z"
        fill="#EB001B"
      />
      <path
        d="M19.1795 8C19.1795 8.93817 18.9156 9.85743 18.4179 10.6527C17.9201 11.448 17.2087 12.0871 16.3649 12.4972C15.5211 12.9072 14.5789 13.0716 13.6461 12.9714C12.7133 12.8713 11.8274 12.5108 11.0899 11.931C11.685 11.4631 12.1661 10.8661 12.4969 10.1852C12.8277 9.50421 12.9996 8.75705 12.9996 8C12.9996 7.24295 12.8277 6.49579 12.4969 5.81484C12.1661 5.13389 11.685 4.53694 11.0899 4.069C11.8274 3.48923 12.7133 3.12868 13.6461 3.02856C14.5789 2.92844 15.5211 3.09279 16.3649 3.50283C17.2087 3.91287 17.9201 4.55205 18.4179 5.34731C18.9156 6.14257 19.1795 7.06183 19.1795 8Z"
        fill="#00A2E5"
      />
    </svg>
  );
};
export default Maestro;
